import { EventProvider } from 'contexts/event-context';
import { EventRouting } from './event-routing';
import { useParams } from 'react-router-dom';

import 'styles/event.css';
import { ErrorBoundary } from 'components';

export const EventSetup = () => {
    const { eventAlias } = useParams();

    return (
        <ErrorBoundary baseRelativeUrl={`/${eventAlias}`}>
            <EventProvider eventAlias={eventAlias!}>
                <EventRouting />
            </EventProvider>
        </ErrorBoundary>
    );
};
